import {Service} from 'typedi';
import {action, autorun, makeObservable, observable} from 'mobx';
import {IConfig} from '@/types';
import {LANGUAGE} from '@/constants';

const CONFIG_KEY = 'configs';

@Service()
export class ConfigService {
  language: LANGUAGE = LANGUAGE.EN;
  theme: 'light' | 'dark' = 'light';

  constructor() {
    const configsLocalStore = localStorage.getItem(CONFIG_KEY);
    if (configsLocalStore) {
      const configs: IConfig = JSON.parse(Object(configsLocalStore));
      Object.assign(this, configs);
    }
    makeObservable(this, {
      language: observable,
      theme: observable,
      toggleTheme: action.bound,
      setLanguage: action.bound,
    });
    autorun(() => {
      localStorage.setItem(CONFIG_KEY, JSON.stringify(Object(this)));
    });
  }

  toggleTheme() {
    this.theme = this.theme === 'dark' ? 'light' : 'dark';
  }

  setLanguage(language: LANGUAGE) {
    this.language = language;
  }
}
